import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { Box, Typography, Paper } from '@mui/material';
import { Block as BlockIcon } from '@mui/icons-material';

function getRoleDisplayName(role: string) {
  return role === 'manager' ? 'System manager' : role;
}

interface RoleRouteProps {
  children: React.ReactNode;
  allowedRoles: string[];
}

const RoleRoute: React.FC<RoleRouteProps> = ({ children, allowedRoles }) => {
  const user = useAuthStore((state) => state.user);

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (!allowedRoles.includes(user.role)) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
        <Paper sx={{ p: 4, textAlign: 'center', maxWidth: 400 }}>
          <BlockIcon sx={{ fontSize: 60, color: 'error.main', mb: 2 }} />
          <Typography variant="h5" gutterBottom>
            Access Denied
          </Typography>
          <Typography color="textSecondary">
            You don't have permission to access this page.
          </Typography>
          <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
            Your role: <strong>{getRoleDisplayName(user.role)}</strong>
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Required: <strong>{allowedRoles.map(getRoleDisplayName).join(', ')}</strong>
          </Typography>
        </Paper>
      </Box>
    );
  }

  return <>{children}</>;
};

export default RoleRoute;
